import React, { Component } from 'react'
import connexion from '../../connexion'
import Swipeable from 'react-swipeable'
import { Link } from 'react-router-dom'
import './SwipCat.css'
import ThemeIcon from '../UI/ThemeIcon'

class SwipCat extends Component {
	constructor(props) {
		super(props)
		this.theme = [props.theme.color1, props.theme.color2, props.theme.color3, props.theme.color4]
		this.state = {
			translateX: 0,
			categories: null
		}
	}

	componentDidMount() {
		this.loadCategories()
	}

	/*componentDidUpdate(prevProps) {
		if (prevProps.categories !== this.props.categories)
			this.loadCategories()
	}*/

	loadCategories = () => {
		const group = this.props.group._id
		this.props.fetchCategoriesByGroup(group)
		.then(ret => {
			let categories = []
			for (let i = 0; i < ret.length; i++)
			{
				if (ret[i].group === group)
				{
					ret[i].color = { backgroundColor: '#' + this.props.theme.color1 }
					categories.push(ret[i])
				}
			}
			this.setState({ categories: categories })
		})
		.catch(err => console.log(err))
	}

	/* Fonction getTileColor() non appelée à ce stade */
	getTileColor = (index) => {
		const hex = this.props.theme.color1
		const r = parseInt(hex.slice(0, 2), 16)
		const g = parseInt(hex.slice(2, 4), 16)
		const b = parseInt(hex.slice(4, 6), 16)
		const factors = [1.0, 0.72, 0.88, 0.58]
		const f = factors[index % factors.length]
		const nr = Math.min(255, Math.round(r * f))
		const ng = Math.min(255, Math.round(g * f))
		const nb = Math.min(255, Math.round(b * f))
		return `#${nr.toString(16).padStart(2, '0')}${ng.toString(16).padStart(2, '0')}${nb.toString(16).padStart(2, '0')}`
	}

	swipeLeft = (event, absX) => {
		if (this.state.categories)
		{
			const screenWidth = window.innerWidth * 0.9
			const elemWidth = (this.props.group.tiles_photo === true) ? 160 : 120
			const marginWidth = 10
			const totalWidth = (this.state.categories.length * elemWidth) + ((this.state.categories.length - 1) * marginWidth) - screenWidth
			let list = window.document.getElementById(this.props.group._id)
			let translateX = this.state.translateX

			list.style.transition = 'none'
			translateX -= absX
			if (translateX < -totalWidth)
				translateX = -totalWidth + ((translateX + totalWidth) / 3) //élastique : résistance au tiers au-delà du bord
			list.style.transform = "translateX(" + translateX + "px)"
		}
	}

	swipeRight = (event, absX) => {
		if (this.state.categories)
		{
			let list = window.document.getElementById(this.props.group._id)
			let translateX = this.state.translateX

			list.style.transition = 'none'
			translateX += absX
			if (translateX > 0)
				translateX = translateX / 3 //élastique : résistance au tiers avant le bord
			list.style.transform = "translateX(" + translateX + "px)"
		}
	}

	swiped = (event, deltaX, deltaY, isFlick, velocity) => {
		if (!this.state.categories) return
		const screenWidth = window.innerWidth * 0.9
		const elemWidth = (this.props.group.tiles_photo === true) ? 160 : 120
		const marginWidth = 10
		const cardSlot = elemWidth + marginWidth
		const totalWidth = (this.state.categories.length * elemWidth) + ((this.state.categories.length - 1) * marginWidth) - screenWidth
		if (totalWidth <= 0)
		{
			//pas de défilement possible : rebond vers l'origine après un éventuel overdrag
			const list = window.document.getElementById(this.props.group._id)
			if (list)
			{
				list.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
				list.style.transform = 'translateX(0px)'
			}
			this.setState({ translateX: 0 })
			return ;
		}

		const list = window.document.getElementById(this.props.group._id)
		const currentIndex = Math.round(-this.state.translateX / cardSlot)
		const maxIndex = Math.ceil(totalWidth / cardSlot) //ceil : le dernier cran, même partiel, doit être atteignable (translateX est borné à -totalWidth)

		let snapIndex = null
		if (isFlick || velocity > 0.3) {
			// Flick rapide : avancer d'une carte dans la direction du swipe
			snapIndex = deltaX > 0 ? currentIndex + 1 : currentIndex - 1
		} else {
			// Drag lent : projection momentum puis snap à la carte la plus proche
			const projected = this.state.translateX + (deltaX * -1) - (Math.sign(deltaX) * velocity * 160)
			snapIndex = Math.round(-projected / cardSlot)
		}

		snapIndex = Math.max(0, Math.min(snapIndex, maxIndex))
		const translateX = Math.max(-totalWidth, -snapIndex * cardSlot)

		// Durée proportionnelle à la distance parcourue
		const distance = Math.abs(translateX - this.state.translateX)
		const duration = Math.min(0.55, Math.max(0.2, distance / 900))

		list.style.transition = `transform ${duration}s cubic-bezier(0.25, 0.46, 0.45, 0.94)`
		list.style.transform = `translateX(${translateX}px)`
		this.setState({ translateX })
	}

	render() {
		const icons = this.props.icons
		const swipeid = this.props.group._id
		const categories = this.state.categories
		if (categories)
		{
			let prefix = ""
			for (let i = 0; i < this.props.group.translations.length; i++)
			{
				if (this.props.group.translations[i].lang === this.props.user.lang)
				{
					prefix = this.props.group.translations[i].prefix
					break
				}
			}
			const rubricPath = this.props.lang_assets.paths.rubrics + '/' + prefix
			return (
				<div>
					<div className="flex justify-between items-baseline mx-5 mt-7">
						<h2 className="text-xl font-bold">{this.props.title}</h2>
						{categories.length > 3 &&
							<Link to={rubricPath} className="text-sm font-semibold whitespace-nowrap ml-3" style={{ color: '#' + this.props.theme.color1 }}>{this.props.lang_assets.home.see_all} ›</Link>
						}
					</div>
					<Swipeable className="mt-3" onSwiped={this.swiped} onSwipingLeft={this.swipeLeft} onSwipingRight={this.swipeRight}>
						{/* <div className="listElems"> */}
						<div className="w-11/12 m-auto">
							<div className="Slider" id={swipeid}>
							{/* <div className="w-full mb-8 whitespace-nowrap" id={swipeid}> */}
							{categories && categories.map(({ _id, translations, icon, color, page, list, has_cover, tile_mode, has_tile_image }, index) => {
								let iconDoc = null
								for (let i = 0; i < icons.length; i++)
								{
									if (icons[i]._id === icon)
									{
										iconDoc = icons[i]
										break
									}
								}
								let name = ""
								let suffix = ""
								for (let i = 0; i < translations.length; i++)
								{
									if (translations[i].lang === this.props.user.lang)
									{
										name = translations[i].name
										suffix = translations[i].suffix
										break
									}
								}
								let prefix = ""
								for (let i = 0; i < this.props.group.translations.length; i++)
								{
									if (this.props.group.translations[i].lang === this.props.user.lang)
									{
										prefix = this.props.group.translations[i].prefix
										break
									}
								}
								const path = this.props.lang_assets.paths.rubrics + '/'  + prefix + '/' + suffix
								//layout selon le réglage de la rubrique : classique (couleur, titre dedans) ou photo (titre dessous)
								if (this.props.group.tiles_photo !== true)
								{
									return (
										<Link
											className="element"
											to={path}
											key={_id}
										>
											<div className="classic" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
												{(iconDoc) ? <ThemeIcon icon={iconDoc} type="lineal" color="#FFFFFF" legacyTheme="blank" alt="Icône" style={{ width: '40px', opacity: 0.95 }} /> : <span />}
												<p style={{ color: 'white', fontWeight: '600', fontSize: '1.05rem', lineHeight: '1.2', margin: 0 }}>{name}</p>
											</div>
										</Link>
									)
								}
								//dans une rubrique photo, la cover est le défaut ; « custom » la remplace par la photo dédiée
								let tile_source = null
								if (tile_mode === "custom" && has_tile_image)
									tile_source = "custom"
								else if (has_cover)
									tile_source = "cover"
								const tile_photo = (tile_source !== null)
								let visual_style = { backgroundColor: '#' + this.props.theme.color1 }
								if (tile_photo)
								{
									const cover_url = connexion.connect.url + 'webapp/categories/cover?category=' + _id + ((tile_source === "custom") ? '&source=custom' : '')
									visual_style = { backgroundImage: 'url(' + cover_url + ')' }
								}
								return (
									<Link
										className="element element-photo"
										to={path}
										key={_id}
									>
										<div className="visual" style={visual_style}>
											{(!tile_photo && iconDoc) ? <ThemeIcon icon={iconDoc} type="lineal" color="#FFFFFF" legacyTheme="blank" alt="Icône" style={{ width: '40px', opacity: 0.95 }} /> : null}
										</div>
										<p className="tile-title">{name}</p>
									</Link>
								)
							})}
							</div>
						</div>
					</Swipeable>
				</div>
			)
		}
		else
		{
			return (
				<div>
					<Swipeable onSwiped={this.swiped} onSwipingLeft={this.swipeLeft} onSwipingRight={this.swipeRight}>
						<div className="listElems">
							<div className="Slider" id={swipeid}>
								<div className="element"><div className="visual"></div></div>
								<div className="element"><div className="visual"></div></div>
								<div className="element"><div className="visual"></div></div>
								<div className="element"><div className="visual"></div></div>
							</div>
						</div>
					</Swipeable>
				</div>
			)
		}
	}
}

export default SwipCat;